import React from 'react'
import './LoadingScreen.css'
import logo from '../Images/logo-transparent.png'
import loading from "../Images/three-dots.svg"

const LoadingScreen = () => {
  return (
    <div className='loading-con d-flex justify-content-center align-items-center flex-column'>
      <img src={logo} className='logo-loading'  style={{width:"12%"}}/>
      <img src={loading} className='m-5' style={{ width: "5%" }} />
    </div>
  )
}

export default LoadingScreen
